import { useMemo } from 'react';
import { isEmpty } from 'ramda';
import { useSelector } from 'react-redux';

import { useQueryFavouriteGames } from '../../../hooks/API/useQueryFavouriteGames';
import { isLoggedInSelector } from '../../../redux/reducers/app/params';

export const useIsFavoriteGame = (gameId, productType) => {
  const isLoggedIn = useSelector(isLoggedInSelector);

  const { data, isLoading } = useQueryFavouriteGames(
    {
      enabled: isLoggedIn,
    },
    productType
  );

  return useMemo(() => {
    return isLoggedIn && !isLoading && !isEmpty(data)
      ? data?.find((game) => game.id === gameId)
      : false;
  }, [isLoggedIn, isLoading, data, gameId]);
};
